<template>
	<div class="checkbox">

		<input
		type="text"
		readonly="true"
		:class="inputClass">

		<ul
		v-if="list.length !== 0"
		:class="[...inputClass, !active ? 'hidden' : '']"
		class="list-reset">

			<li class="py-1"
			v-for="item in list">

				<label class="checkbox-hover">

					<input type="checkbox" :value="item.value" v-model="model" class="check-custom">

					<span class="check-toggle squared"></span>

					<span class="ml-2">{{ item.text }}</span>

				</label>

			</li>

		</ul>

	</div>
</template>

<script>
	export default {

		name: 'Radio',
		props: {
			inputClass: Array,
			value: Array,
			active: Boolean,
			getList: Function,
			options: Array
		},
		data () {
			return {
				model: '',
				list: [],
				timeout: null,
			}
		},
		watch: {
			model (val) {

				console.log(val)

				this.$emit('input', val)

			}
		},
		created () {

			if (this.options) this.list = this.options

		},
		methods: {

			focus () { this.cargarLista() },

			async cargarLista () {

				if (this.options) return

				const { data } = await this.getList()

				this.list = data.map(el => ({text: el, value: el}))


			}
		}
	}
</script>

<style lang="scss">
	.input-sigarus .checkbox {

		position: relative;

		ul {
			position: absolute;
			top: 0;
			left: 0;
			background-color: #fff;
			border-radius: .25rem;

			li {
				padding: .5rem 1rem;
			}
		}

	}
</style>
